"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _navUtils = require("./utils/navUtils");

var UINavList = _react.default.createClass({
  displayName: "UINavList",
  propTypes: {
    children: _react.PropTypes.node,
    depth: _react.PropTypes.number,
    value: _react.PropTypes.node,
    _rootComponent: _react.PropTypes.func,
    _transformChildProps: _react.PropTypes.func
  },
  getDefaultProps: function getDefaultProps() {
    return {
      depth: 0,
      value: null,
      _transformChildProps: function _transformChildProps() {
        return {};
      }
    };
  },
  rerenderFromRoot: function rerenderFromRoot(children) {
    if (children == null) return null;
    var _this$props = this.props,
        depth = _this$props.depth,
        value = _this$props.value,
        _rootComponent = _this$props._rootComponent,
        _transformChildProps = _this$props._transformChildProps;
    var Root = _rootComponent || UINavList;
    var props = {
      depth: depth + 1,
      value: value,
      _rootComponent: _rootComponent,
      _transformChildProps: _transformChildProps
    };
    return _react.default.createElement(Root, props, children);
  },
  render: function render() {
    var _this = this;

    var _this$props2 = this.props,
        children = _this$props2.children,
        className = _this$props2.className,
        depth = _this$props2.depth,
        __rootComponent = _this$props2._rootComponent,
        _transformChildProps = _this$props2._transformChildProps,
        value = _this$props2.value,
        rest = (0, _objectWithoutProperties2.default)(_this$props2, ["children", "className", "depth", "_rootComponent", "_transformChildProps", "value"]);
    var classes = (0, _classNames.default)(className, 'private-nav__wrapper');
    return _react.default.createElement("nav", (0, _extends2.default)({}, rest, {
      className: classes
    }), _react.default.createElement("ul", {
      className: "private-nav private-nav--level-" + depth
    }, _react.Children.map(children, function (child) {
      if (!_react.default.isValidElement(child)) {
        return child;
      }

      var defaultOpen = child && child.props && child.props.defaultOpen;
      return (0, _react.cloneElement)(child, (0, _extends2.default)({
        active: (0, _navUtils.isChildActive)(child, value),
        defaultOpen: defaultOpen || (0, _navUtils.containsActiveChild)(child, value),
        value: undefined,
        _rootRenderer: _this.rerenderFromRoot
      }, _transformChildProps(child.props)));
    })));
  }
});

var _default = UINavList;
exports.default = _default;
module.exports = exports.default;